export const SET_CURRENT_ANSWER = 'SET_CURRENT_ANSWER';
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const SET_ERROR = 'SET_ERROR';
export const SET_SHOW_RESULTS = 'SET_SHOW_RESULTS';
export const SET_SHOW_STARTING = 'SET_SHOW_STARTING';
export const SET_ANSWERS = 'SET_ANSWERS';
export const RESET_QUIZ = 'RESET_QUIZ';
export const SET_SCORE = 'SET_SCORE';
export const SET_HEALTH= 'SET_HEALTH';